(function () {
  const checkedAttribute = 'data-tinkertime-cart-limit-checked';
  const limitSelector = '[data-tinkertime-cart-limit]';
  const defaultMessage = 'You can only add 3 of this item to your cart.';
  let cartRefreshPromise = null;

  function getLimitForForm(form) {
    const limitElement = form.closest(limitSelector);
    const limit = Number(limitElement && limitElement.dataset.tinkertimeCartLimit);
    return Number.isFinite(limit) && limit > 0 ? limit : null;
  }

  function getVariantId(form) {
    const idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getAddQuantity(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? Number(quantityInput.value) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getLimitMessage(limit) {
    if (window.cartStrings && window.cartStrings.quantityError) {
      return window.cartStrings.quantityError.replace('[quantity]', limit);
    }

    return defaultMessage;
  }

  function getCurrentVariantQuantity(cart, variantId) {
    return cart.items.reduce((total, item) => {
      return String(item.id) === String(variantId) ? total + item.quantity : total;
    }, 0);
  }

  function getLimitedForms() {
    return Array.from(document.querySelectorAll(`${limitSelector} form, form${limitSelector}`)).filter((form) => {
      const action = form.getAttribute('action') || '';
      return action.includes('/cart/add') && getVariantId(form);
    });
  }

  function getCart(force = false) {
    if (force) cartRefreshPromise = null;

    if (!cartRefreshPromise) {
      cartRefreshPromise = fetch(window.routes ? window.routes.cart_url + '.js' : '/cart.js', {
        credentials: 'same-origin',
      })
        .then((response) => response.json())
        .finally(() => {
          cartRefreshPromise = null;
        });
    }

    return cartRefreshPromise;
  }

  function getJsonRoute(route, fallback) {
    if (!route) return fallback;
    return route.endsWith('.js') ? route : `${route}.js`;
  }

  function getErrorWrapper(form) {
    const productForm = form.closest('product-form');
    const existingWrapper =
      (productForm && productForm.querySelector('.product-form__error-message-wrapper')) ||
      form.querySelector('.product-form__error-message-wrapper') ||
      form.parentElement.querySelector('.tinkertime-cart-limit-error');

    if (existingWrapper) return existingWrapper;

    const wrapper = document.createElement('div');
    wrapper.className = 'tinkertime-cart-limit-error product-form__error-message-wrapper';
    wrapper.setAttribute('role', 'alert');
    wrapper.setAttribute('hidden', '');

    const message = document.createElement('span');
    message.className = 'product-form__error-message';
    wrapper.append(message);

    form.append(wrapper);
    return wrapper;
  }

  function showError(form, message) {
    const wrapper = getErrorWrapper(form);
    const messageElement = wrapper.querySelector('.product-form__error-message') || wrapper;

    wrapper.removeAttribute('hidden');
    messageElement.textContent = message;
  }

  function clearError(form) {
    const wrapper =
      form.querySelector('.product-form__error-message-wrapper') ||
      form.parentElement.querySelector('.tinkertime-cart-limit-error');

    if (wrapper) wrapper.setAttribute('hidden', '');
  }

  function restoreSubmitButton(form) {
    const button = form.querySelector('[type="submit"]');
    const spinner = form.querySelector('.loading__spinner');

    if (button) {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    }

    if (spinner) spinner.classList.add('hidden');
  }

  function setSubmitButtonBusy(form, isBusy) {
    const button = getSubmitButton(form);
    const spinner = form.querySelector('.loading__spinner');

    if (button) {
      button.toggleAttribute('aria-disabled', isBusy);
      button.classList.toggle('loading', isBusy);
    }

    if (spinner) spinner.classList.toggle('hidden', !isBusy);
  }

  function getCartPresenter() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToCart(form, quantityOverride) {
    const cartPresenter = getCartPresenter();
    const formData = new FormData(form);

    if (quantityOverride !== undefined) {
      formData.set('quantity', quantityOverride);
    }

    if (cartPresenter) {
      formData.append(
        'sections',
        cartPresenter.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cartPresenter.setActiveElement(document.activeElement);
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    setSubmitButtonBusy(form, true);

    return fetch(window.routes ? window.routes.cart_add_url : '/cart/add', config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || defaultMessage);
        }

        if (cartPresenter) {
          cartPresenter.renderContents(response);
        } else {
          updateCartIconBubble(response);
        }

        if (response.id && response.quantity !== undefined) {
          updateVariantControls(response.id, response.quantity);
        }

        return getCart(true).then((cart) => {
          refreshQuantityControls(cart);
          if (response.id && response.quantity !== undefined) {
            updateVariantControls(response.id, getCurrentVariantQuantity(cart, response.id) || response.quantity);
          }
          return response;
        });
      })
      .catch((error) => {
        showError(form, error.message || defaultMessage);
      })
      .finally(() => {
        setSubmitButtonBusy(form, false);
      });
  }

  function updateCartIconBubble(cart) {
    const target = document.querySelector('#cart-icon-bubble');
    if (!target) return;

    let bubble = target.querySelector('.cart-count-bubble');

    if (cart.item_count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        target.append(bubble);
      }

      bubble.innerHTML = `
        <span aria-hidden="true">${cart.item_count}</span>
        <span class="visually-hidden">${cart.item_count} item${cart.item_count === 1 ? '' : 's'}</span>
      `;
    } else if (bubble) {
      bubble.remove();
    }
  }

  function getSubmitButton(form) {
    return form.querySelector('[type="submit"]');
  }

  function ensureMainButtonCount(form, limit) {
    const submitButton = getSubmitButton(form);
    if (!submitButton) return null;

    Array.from(submitButton.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        const originalText = document.createElement('span');
        originalText.className = 'tinkertime-cart-inline-control__original-text';
        originalText.textContent = node.textContent.trim();
        node.replaceWith(originalText);
      }
    });

    submitButton.classList.add('tinkertime-cart-inline-control__main');

    let count = submitButton.querySelector('.tinkertime-cart-inline-control__count');
    if (!count) {
      count = document.createElement('span');
      count.className = 'tinkertime-cart-inline-control__count';
      count.textContent = '0';
      submitButton.append(count);
    }

    return count;
  }

  function createQuantityControl(form, limit) {
    const control = document.createElement('div');
    control.className = 'tinkertime-cart-inline-control';
    control.dataset.variantId = getVariantId(form);
    if (form.closest('[class*="ai-beta-catalog__buttons-"]')) {
      control.classList.add('tinkertime-cart-inline-control--catalog');
      form.closest('product-form')?.classList.add('tinkertime-cart-inline-control-host--catalog');
    }

    control.innerHTML = `
      <button class="tinkertime-cart-inline-control__step" type="button" data-cart-limit-action="decrease" aria-label="Decrease quantity">-</button>
      <button class="tinkertime-cart-inline-control__step" type="button" data-cart-limit-action="increase" aria-label="Increase quantity">+</button>
    `;

    const decrease = control.querySelector('[data-cart-limit-action="decrease"]');
    const increase = control.querySelector('[data-cart-limit-action="increase"]');
    ensureMainButtonCount(form, limit);

    control.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-limit-action]');
      if (!button || button.disabled) return;

      const action = button.dataset.cartLimitAction;
      changeQuantity(form, action === 'increase' ? 1 : -1);
    });

    const parent = form.parentNode;
    parent.insertBefore(control, form);
    control.insertBefore(decrease, control.firstChild);
    control.insertBefore(form, increase);

    return control;
  }

  function getQuantityControl(form) {
    const variantId = getVariantId(form);
    const limit = getLimitForForm(form);
    if (!variantId || !limit) return null;

    const parent = form.parentElement;
    if (parent && parent.classList.contains('tinkertime-cart-inline-control')) return parent;

    return createQuantityControl(form, limit);
  }

  function updateQuantityControl(form, quantity) {
    const limit = getLimitForForm(form);
    const control = getQuantityControl(form);
    if (!control || !limit) return;

    const value = ensureMainButtonCount(form, limit);
    const submitButton = getSubmitButton(form);
    const decrease = control.querySelector('[data-cart-limit-action="decrease"]');
    const increase = control.querySelector('[data-cart-limit-action="increase"]');

    value.textContent = String(quantity);
    control.classList.toggle('has-cart-count', quantity > 0);
    if (submitButton) submitButton.classList.toggle('has-cart-count', quantity > 0);
    decrease.disabled = quantity <= 0;
    increase.disabled = quantity >= limit;
  }

  function setControlBusy(form, isBusy) {
    const control = getQuantityControl(form);
    if (!control) return;

    control.toggleAttribute('aria-busy', isBusy);
    if (!isBusy) return;

    control.querySelectorAll('[data-cart-limit-action]').forEach((button) => {
      button.disabled = true;
    });
  }

  function refreshQuantityControls(cart) {
    const currentCart = cart;
    getLimitedForms().forEach((form) => {
      const quantity = getCurrentVariantQuantity(currentCart, getVariantId(form));
      updateQuantityControl(form, quantity);
    });
    updateCartIconBubble(currentCart);
  }

  function updateVariantControls(variantId, quantity) {
    getLimitedForms().forEach((form) => {
      if (String(getVariantId(form)) === String(variantId)) {
        updateQuantityControl(form, quantity);
      }
    });
  }

  function refreshCartState() {
    return getCart().then((cart) => {
      refreshQuantityControls(cart);
      return cart;
    });
  }

  function changeQuantity(form, delta) {
    const variantId = getVariantId(form);
    const limit = getLimitForForm(form);
    if (!variantId || !limit) return;

    getCart().then((cart) => {
      const currentQuantity = getCurrentVariantQuantity(cart, variantId);
      const nextQuantity = Math.max(0, Math.min(limit, currentQuantity + delta));

      if (nextQuantity === currentQuantity) {
        if (delta > 0) showError(form, getLimitMessage(limit));
        return;
      }

      clearError(form);
      setControlBusy(form, true);

      if (delta > 0) {
        addToCart(form, 1).finally(() => {
          setControlBusy(form, false);
          refreshCartState();
        });
        return;
      }

      fetch(getJsonRoute(window.routes && window.routes.cart_change_url, '/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: nextQuantity,
        }),
      })
        .then(() => getCart(true))
        .then((cart) => {
          refreshQuantityControls(cart);
        })
        .finally(() => {
          setControlBusy(form, false);
          refreshCartState();
        });
    });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      const limit = getLimitForForm(form);
      if (!limit) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const variantId = getVariantId(form);
      if (!variantId) return;

      getCart()
        .then((cart) => {
          const currentQuantity = getCurrentVariantQuantity(cart, variantId);
          const requestedQuantity = getAddQuantity(form);

          if (currentQuantity + requestedQuantity > limit) {
            showError(form, getLimitMessage(limit));
            restoreSubmitButton(form);
            return;
          }

          clearError(form);
          addToCart(form);
        })
        .catch(() => {
          addToCart(form);
        });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartState);
  } else {
    refreshCartState();
  }

  document.addEventListener('cart:refresh', refreshCartState);
})();
